import { Code } from '@mantine/core';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const replacer = (_key: any, _value: any[]) => {
  if (_value instanceof Map) {
    return {
      dataType: 'Map',
      value: Array.from(_value.entries()), // or with spread: value: [...value]
    };
  }

  return _value;
};

interface GraphqlDumpDataProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any;
}

function GraphqlDumpData({ data }: GraphqlDumpDataProps) {
  return <Code block>DATA: {JSON.stringify(data, replacer, 2)}</Code>;
}

export default GraphqlDumpData;
